module.exports = __webpack_public_path__ + "8ae44259d901bf14369bce579b22ad92.pdf";